var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileCard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 40.313,
    viewBox: "0 0 48 40.313",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:rgba(11,183,167,0.4);}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -41)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M241.906,377h-7.5a1.406,1.406,0,0,0,0,2.813h7.5a1.406,1.406,0,0,0,0-2.812Z",
    transform: "translate(-211.156 -304.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M234.406,315.813h5.25a1.406,1.406,0,0,0,0-2.812h-5.25a1.406,1.406,0,0,0,0,2.813Z",
    transform: "translate(-211.156 -246.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M48,52.156A11.156,11.156,0,0,0,26.3,48.5H4.219A4.224,4.224,0,0,0,0,52.719V77.094a4.224,4.224,0,0,0,4.219,4.219H39.187a4.224,4.224,0,0,0,4.219-4.219V61.172A11.148,11.148,0,0,0,48,52.156ZM36.844,43.813A8.344,8.344,0,1,1,28.5,52.156,8.353,8.353,0,0,1,36.844,43.813Zm3.75,33.281A1.408,1.408,0,0,1,39.187,78.5H4.219a1.408,1.408,0,0,1-1.406-1.406V52.719a1.408,1.408,0,0,1,1.406-1.406h21.5q-.031.418-.032.844A11.156,11.156,0,0,0,40.594,62.663Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M347.645,127.535a1.406,1.406,0,0,0,1.1.768,1.433,1.433,0,0,0,.162.009,1.407,1.407,0,0,0,1.08-.506l3.75-4.5a1.406,1.406,0,0,0-2.161-1.8l-2.373,2.848-.538-1.077a1.406,1.406,0,0,0-2.516,1.258Z",
    transform: "translate(-313.559 -72.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M74.571,217.779a5.156,5.156,0,1,0-7.329,0A5.9,5.9,0,0,0,65,222.406v3.75a1.406,1.406,0,0,0,1.406,1.406h9a1.406,1.406,0,0,0,1.406-1.406v-3.75A5.9,5.9,0,0,0,74.571,217.779Zm-6.008-3.623a2.344,2.344,0,1,1,2.344,2.344A2.346,2.346,0,0,1,68.563,214.156ZM74,224.75H67.813v-2.344a3.094,3.094,0,0,1,6.188,0Z",
    transform: "translate(-58.906 -152.25)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCard);
export default __webpack_public_path__ + "static/media/profile-card.be3e4645595594c80098c52fe5de4c86.svg";
export { ForwardRef as ReactComponent };